<template>
  <div>
    <!-- 添加升级任务弹出框 -->
    <task-dialog :title="$t('lang.upgrade.addDistributionPackages')" ref="Dialog" :packlist="packlist"
      @getupgradelist="listLevelUp" :radio="radio">
      <!-- 插槽添加选项 -->
      <!-- 是否保留固件升级 -->
      <div style="text-align:center;margin-top:10px;">
        <el-radio v-model="radio" label="1" style="padding-right:20px;">{{ $t('lang.upgrade.upgrades') }}</el-radio>
        <el-radio v-model="radio" label="0" style="padding-right:40px;">{{ $t('lang.upgrade.Dont') }}</el-radio>
      </div>
    </task-dialog>
    <!-- 创建任务 -->
    <el-button type="primary" size="mini" class="elinput" @click="showDialog" v-if="Permission.indexOf(127) != -1">
      {{ $t('lang.upgrade.hFirstTask') }}
    </el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(128) != -1"></xlsx>
    <!-- <p class="tabletitle"></p> -->
    <!-- 表格组件 -->
    <el-select v-model="ListStatusValue" size="mini" @change="GetStatusList">
      <el-option v-for="item in ListStatus" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <div>
      <TableComponent :data="data" :RowKey="'tId'" :Expand="true" :slot="true" :seek="seek"
        :DeleteTitle="$t('lang.upgrade.CompositeTask')" :Columns="Columns" :ColuumnsButton="ColuumnsButton"
        :Expands="Expands" :ExpandKey="'subTasks'" :ExpandsButton="ExpandsButton" @sortChange="sortChange"
        @GetConfig="GetConfig" @GetPackageType="GetPackageType" @GetSpName="GetSpName" @GetChildSn="GetChildSn"
        @GetChildStatus="GetChildStatus" @delSonLevelUp="delSonLevelUp" @delLevelUp="delLevelUp"
        @GetSubtasks="GetSubtasks">
        <span slot="ChildSlot" slot-scope="scope" style="color:#409eff;font-size:15px;">{{ scope.scope.$index + 1 }}</span>
        <el-progress slot="slot" slot-scope="scope" :percentage="~~(scope.scope.row.progress * 100)"
          :color="customColorMethod" />
        <!-- <div slot="otherSlot" slot-scope="scope" >设备总数：{{scope.scope.$index+1}}<br>升级成功：{{scope.scope.$index+1}}<br>升级失败：{{scope.scope.$index+1}}</div> -->
      </TableComponent>
      <!--分页组件-->
      <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges">
      </pagination>
    </div>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import TaskDialog from "../components/dialog/UpgradeDialog";
import {
  listLevelUp,
  getSoftwarePackageList,
  delLevelUp,
  queryKeyword,
  delSonLevelUp,
  GetListConfig
} from "@/api/upgrade"
import { getPermission } from "../../../cookie/cookie"
import { PublicComponent } from "../../../mixins/common"
import dialog from '@/components/Dialog'
import TableComponent from '@/components/TableComponent'
import { Columns, ColuumnsButton, Expands, ExpandsButton } from './TableConfig'
export default {
  mixins: [PublicComponent],
  data() {
    return {
      Columns: Columns,
      ColuumnsButton: ColuumnsButton,
      Expands: Expands,
      ExpandsButton: ExpandsButton,
      Permission: [],
      data: [],
      value: "",
      input: "",
      seek: {
        tName: "",
        tDescription: "",
        progress: "",
        spName: "",
        updatetime: ""
      },
      radio: "1",
      //文件地址选项
      FirmwareList: [
        { value: 0, label: this.$t('lang.upgrade.BackupServer') },
        { value: 1, label: this.$t('lang.upgrade.DefaultServer') }
      ],
      //文件地址选中值
      FirmwareValue: 0,
      sort: {
        tName: null,
        tDescription: null,
        progress: null,
        spName: null,
        updatetime: null
      },
      packlist: [],
      //定时器函数
      Refresh: null,
      //状态下拉框
      ListStatus: [
        { label: this.$t("lang.upgrade.MissionAccomplished"), value: 1 },
        { label: this.$t("lang.upgrade.Ongoing"), value: 0 }
      ],
      //状态下拉框选中值
      ListStatusValue: 1,
      //获取子任务Tid
      tid: undefined
    };
  },
  components: {
    pagination,
    xlsx,
    TaskDialog,
    dialog,
    TableComponent
  },
  methods: {
    //表格选择框
    handleSelectionChange(val) {
      console.log(val);
    },
    //弹出添加任务组件并且获取软件包列表
    showDialog() {
      getSoftwarePackageList().then(res => {
        this.packlist = res.data.data.list;
      });
      this.$refs.Dialog.showDialog();
    },
    //获取升级列表
    listLevelUp(state = this.ListStatusValue, tid) {
      listLevelUp(this.offset, this.limit, state, tid).then(res => {
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.data.unshift({});
      });
    },
    //删除升级任务
    delLevelUp(row) {
      delLevelUp(row.tId).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.upgrade.TestDelete"),
            type: "success"
          });
          this.queryKeyword();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.upgrade.bdb_delete"),
            type: "warning"
          });
        }
      });
    },
    //搜索排序
    queryKeyword() {
      queryKeyword(
        [
          this.seek.tName,
          this.seek.tDescription,
          this.seek.progress,
          this.seek.spName,
          this.seek.updatetime
        ],
        this.offset,
        this.limit,
        this.sort,
        this.ListStatusValue,
        this.tid
      ).then(res => {
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.data.unshift({});
        //获取到数据后添加一条空数据
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        tName: null,
        tDescription: null,
        progress: null,
        spName: null,
        updatetime: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.upgrade.FutureTask")) {
        this.sort.tName = sortlist;
      } else if (label == this.$t("lang.upgrade.TaskStatus")) {
        this.sort.tDescription = sortlist;
      } else if (label == this.$t("lang.upgrade.completion")) {
        this.sort.progress = sortlist;
      } else if (label == this.$t("lang.upgrade.createFile")) {
        this.sort.spName = sortlist;
      } else if (label == this.$t("lang.upgrade.UPDATE_TO")) {
        this.sort.updatetime = sortlist;
      }
    },
    //删除任务列表设备
    delSonLevelUp(row) {
      console.log(row);
      delSonLevelUp(row.stId).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.upgrade.TestDelete"),
            type: "success"
          });
          this.queryKeyword();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.upgrade.bdb_delete"),
            type: "warning"
          });
        }
      });
    },
    //表格添加颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    //进度条颜色
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    //是否保留配置升级
    GetConfig(row) {
      return row.tConfig == 1 ? this.$t("lang.upgrade.Keep") : this.$t("lang.upgrade.Dont")
    },
    //任务类型
    GetPackageType(row) {
      switch (row.tPackageType) {
        case undefined:
          return this.$t("lang.upgrade.UpgradeTask")
        case 'upgrade':
          return this.$t("lang.upgrade.UpgradeTask")
        case 'patch':
          return this.$t("lang.upgrade.PatchTask")
        case 'normal':
          return this.$t("lang.upgrade.normalTask")
      }
    },
    //获取文件名
    GetSpName(row) {
      return row.saftwarePackage.spName
    },
    //获取子任务设备序列号
    GetChildSn(row) {
      return row.device.deviceSn
    },
    //获取子任务状态
    GetChildStatus(row) {
      switch (row) {
        case '0':
          return { status: 'success', TagName: this.$t('lang.upgrade.$_blacklistedScalarArgsCallback') }
        case '1':
          return { status: '', TagName: this.$t('lang.upgrade.define') }
        case '2':
          return { status: 'success', TagName: this.$t('lang.upgrade.DownloadEventNotifier') }
        case '3':
          return { status: '', TagName: this.$t('lang.upgrade.upgrading') }
        case '4':
          return { status: 'success', TagName: this.$t('lang.upgrade.upgrade_drush_command') }
        case '5':
          return { status: 'warning', TagName: this.$t('lang.upgrade.username_last_used') }
        case '6':
          return { status: 'warning', TagName: this.$t('lang.upgrade.tempfile') }
        case '7':
          return { status: 'warning', TagName: this.$t('lang.upgrade.Translators') }
        case '8':
          return { status: 'warning', TagName: this.$t('lang.upgrade.zxid_add_name_field') }
        case '9':
          return { status: 'warning', TagName: this.$t('lang.upgrade.DOWNLOADER_CLIENT_TLS_METHOD') }
        case '11':
          return { status: 'warning', TagName: this.$t('lang.upgrade.BAG_FILTER_EQUIPMENT') }
        case '13':
          return { status: 'warning', TagName: this.$t("lang.upgrade.Version_NOT_SURPPORT") }
        case 'A':
          return { status: 'warning', TagName: this.$t('lang.upgrade.boolCheckPingURI') }
        case 'B':
          return { status: 'warning', TagName: this.$t('lang.upgrade.upgrade_alter_tables') }
        case 'C':
          return { status: 'warning', TagName: this.$t('lang.upgrade.keymaster_error_t') }
        case 'D':
          return { status: 'success', TagName: this.$t('lang.upgrade.commands') }
        case 'E':
          return { status: 'warning', TagName: this.$t('lang.upgrade.keymaster_error_t') }
        case 'F':
          return { status: 'success', TagName: this.$t('lang.upgrade.connection') }
        case 'G':
          return { status: 'warning', TagName: this.$t('lang.upgrade.handle_remote_sigint') }
        default: return { status: '', TagName: this.$t("lang.upgrade.unknownError") }
      }
    },
    //获取当前点击的任务Tid
    GetSubtasks(tid) {
      this.tid = tid
      //当前选中的是正在进行的任务
      if (this.ListStatusValue == 0) {
        this.queryKeyword()
      } else {
        //获取当前选中完成任务列表
        // listLevelUp(this.offset, this.limit, this.ListStatusValue)
        //   .then((res) => {
        //     this.data = res.data.data.list
        //     this.total = res.data.data.total
        //     this.data.unshift({})
            // 获取当前点击的任务子任务列表
            GetListConfig(tid)
              .then((res) => {
                this.data.forEach((element, index) => {
                  if (element.tId == tid) {
                    this.$set(this.data[index], 'subTasks', res.data.queryResult)
                    // this.data[index].subTasks=res.data.queryResult
                  }
                });
              })
          // })
      }
    },
    //根据选中的任务类型(正在进行，完成任务)获取子任务
    GetStatusList() {
      clearInterval(this.Refreshs)
      this.Refreshs = null
      if (this.ListStatusValue == 0) {
        //查询一次最新的正在进行任务
        this.queryKeyword()
        //获取当前任务列表
        this.Refreshs = setInterval(() => {
          this.queryKeyword()
        }, 5000);
      } else {
        //查询一次最新的正在完成任务
        this.queryKeyword()
        //清除定时器
        clearInterval(this.Refreshs)
        this.Refreshs = null
      }
    }
  },
  mounted() {
    //获取当前数据列表
    this.listLevelUp();
    //获取存储在cookie里的权限
    this.Permission = getPermission();
  },
  beforeDestroy() {
    //页面销毁前(路由跳转前删除定时器)
    clearInterval(this.Refresh);
  }
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.select {
  width: 3rem;
  margin: 0.2rem;
}

.rightcons {
  float: right;
}

.success-row {
  background: #f0f9eb;
}

.rightinput {
  display: inline-block;
  width: 3rem;
  margin: 0.2rem;
}

.concen {
  text-align: center;
}

.adduserinput {
  display: inline-block;
  width: 50%;
  margin: 0.2rem;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}

.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.tetxp {
  display: inline-block;
  width: 2.7rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
</style>
